/* start.js */
import {bootstrap, container} from './services.js';
// import flatpickr from 'flatpickr';
import flatpickr from 'flatpickr/dist/flatpickr.js';
import 'flatpickr/dist/flatpickr.css';
import './scss/HzTree.scss';
import TomSelectAccessibility from './services/TomSelectAccessibility.js';

export function start() {

    /** @type {import('./include/services/DOMChangeObserver.js').DOMChangeObserver} */
    const observer = container.resolve('observer');

    // Start datepicker on initial and subsequently inserted FormZero fragments.
    observer.attachCallback((node) => {
        const pickers = [
            ...(node.matches?.('[data-provide="datepicker"]') ? [node] : []),
            ...node.querySelectorAll('[data-provide="datepicker"]'),
        ];
        pickers.forEach((picker) => {
            if (!picker._flatpickr) {
                flatpickr(picker, {wrap: true, disableMobile: true});
            }
        });
    }, true);

    // Start jscombo over a jstree
    document.querySelectorAll('[data-jscombo="jstree"]').forEach((element) => {
        const jscombo = container.resolve('jscombo');
        // Create a URLSearchParams object from the query string
        const params = new URLSearchParams(window.location.search);
        jscombo.initialize(element, 'id', params.get('id'), window.location.origin + window.location.pathname, 'lf-nd-');
        jscombo.render();
    });

    // Store "area" in cookies when changed
    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('a[data-area]');
        if (trigger) {
            event.stopPropagation();
            const cookieManager = container.resolve('cookieManager');
            cookieManager.set('AREA', trigger.getAttribute('data-area'), 365);
        }
    }, true);

    // Password Strenght meter
    console.log('Attaching Password Strenght meter');
    document.querySelectorAll('input[type="password"]').forEach((password) => {
        const passwordMeter = container.resolve('passwordMeter');
        passwordMeter.initialize(password);
    });

    // Activating scroller on overflow
    document.querySelectorAll('[data-scroller="horizontal"]').forEach((scroller) => {
        console.log('Applying data scroller to elements ...');
        container.resolve('betterScroll', scroller, {
            scrollX: true,        // Enable horizontal scrolling
            scrollY: false,       // Disable vertical scrolling
            momentum: true,       // Smooth scrolling
            bounce: true,         // Bounce effect at the edges
            click: true,
            mouseWheel: {
                speed:    5,      // Adjust scrolling speed
                invert:   true,   // Invert direction for horizontal scroll
                easeTime: 300     // Duration of easing for the scroll
            }
        });
    });

    // Carousel
    observer.attachCallback((node) => {
        console.log('Attaching Carousel');
        node.querySelectorAll('[data-carousel]').forEach((element) => {
            const timing = Number(element.getAttribute('data-carousel'));
            const carousel = new bootstrap.Carousel(element, {
                interval: timing,
                touch: true,
                ride: 'carousel',
                wrap: true,
                keyboard: true,
                pause: 'hover'
            });
            element.addEventListener('slide.bs.carousel', function(e) {
                if (e.relatedTarget) {
                    var lazy = e.relatedTarget.querySelector('img[data-carousel-src]');
                    if (lazy) {
                        lazy.setAttribute('src', lazy.getAttribute('data-carousel-src'));
                        lazy.removeAttribute('data-carousel-src');
                    }
                }
            });
        });
    }, true);

    /**
     * Riorganizza il la disposizione delle immagini a seconda del valore del data-grid:
     */
    observer.attachCallback((node) => {
        console.log('Attaching GridManager');
        const gridManager = container.resolve('gridManager');
        node.querySelectorAll('[data-grid-mode]').forEach((element) => {
            const mode = element.getAttribute('data-grid-mode');
            gridManager.isotope(element, mode, '[data-grid-item="master"]', '[data-grid-item="size"]');
        });
    }, true);

    /**
     * Trasformazione in Gallery
     */
    observer.attachCallback((node) =>{
        console.log('Attaching LuminousManager');
        const luminousManager = container.resolve('luminousManager');
        luminousManager.gallery(node.querySelectorAll('[data-luminous="gallery"]'));
    }, true);

    /**
     * TomSelect
     */
    const tomSelectAccessibility = new TomSelectAccessibility(container.resolve('translator'));
    observer.attachCallback((node) => {
        const selects = [
            ...(node.matches?.('[data-selector="tom"]') ? [node] : []),
            ...node.querySelectorAll('[data-selector="tom"]'),
        ];
        selects.forEach((element) => {
            // Reordered nodes retain their Tom Select instance; do not initialize again.
            if (element.tomselect) return;
            container.resolve('tomSelect', element, {
                plugins: {
                    remove_button: {
                        html: () => tomSelectAccessibility.createRemoveButton(),
                    },
                },
                create: false,          // set to true if you want tag creation
                // maxItems: 5,
                // placeholder: 'Select…',
                maxOptions: 10000,        // good default; handles large lists well
                onInitialize: function () {
                    tomSelectAccessibility.initialize(this);
                },
                onDropdownOpen: function () {
                    tomSelectAccessibility.syncOptions(this);
                },
                onItemAdd: function () {
                    tomSelectAccessibility.sync(this);
                },
                onItemRemove: function () {
                    tomSelectAccessibility.sync(this);
                },
                render: {
                    option: function (data, escape) {
                        return `<div class="option"
                                    style="background-color:${data.bg};color:${data.color}">
                                    ${escape(data.text)}
                                </div>`;
                    },
                    // item: function (data, escape) {
                    //     return `<div class="item"
                    //                 style="background-color:${data.bg};color:${data.color}">
                    //                 ${escape(data.text)}
                    //             </div>`;
                    // },
                },                
            });
        });        
    }, true);

    // /**
    //  * TagSelector
    //  */
    // observer.attachCallback((node) =>{
    //     console.log('Attaching TagSelector');
    //     node.querySelectorAll('[data-selector="tag"]').forEach((element) => {
    //         container.resolve('tagSelector', element);
    //     });        
    // }, true);

    // ScrollHandler
    const scrollHandler = container.resolve('scrollHandler');
    scrollHandler.initialize();

    // DynamicFormHandler
    document.querySelectorAll('form[data-dh-form]').forEach((form) => {
        console.log('Attaching DynamicFormHandler');
        const dynamicFormHandler = container.resolve('dynamicFormHandler');
        dynamicFormHandler.init(form);
    });

    // Accessible clear button for SearchElement fields, including AJAX content.
    observer.attachCallback((node) => {
        const controls = [];

        if (node.matches?.('[data-search-clear]')) {
            controls.push(node);
        }
        node.querySelectorAll?.('[data-search-clear]').forEach((control) => controls.push(control));

        controls.forEach((control) => {
            container.resolve('searchClearButton').init(control);
        });
    }, true);

    // Article in-page navigation, including dynamically loaded articles.
    observer.attachCallback((node) => {
        const navigations = [];

        if (node.matches?.('[data-article-anchor-nav]')) {
            navigations.push(node);
        }
        node.querySelectorAll?.('[data-article-anchor-nav]').forEach((navigation) => navigations.push(navigation));

        navigations.forEach((navigation) => {
            container.resolve('articleAnchorNavigation').init(navigation);
        });
    }, true);

    // DynamicDataLoader
    const dynamicDataLoader = container.resolve('dynamicDataLoader');
    dynamicDataLoader.init();

    // Confirm legacy links and protected form submissions before any page/AJAX action.
    container.resolve('legacyConfirmActions').init(document);

    // TippyManager owns the single Tippy instance for every element.
    const tippyManager = container.resolve('tippyManager');
    observer.attachCallback((node) => {
        tippyManager.init(node);
    }, true);

    // Confirmation actions enhance the Tippy instance created by TippyManager.
    const tippyConfirm = container.resolve('tippyConfirm');
    observer.attachCallback((node) => {
        tippyConfirm.init(node);
    }, true);

    // TimezoneDetector boot
    document.querySelectorAll('input[data-controller="timezone"]').forEach((field) => {
        console.log('Attaching TimezoneDetector');
        const timezoneDetector = container.resolve('timezoneDetector');
        timezoneDetector.init(field);
    });

    // SkipContentHandler Boot
    document.querySelectorAll('[data-controller="skip-content"]').forEach((nav) => {
        console.log('Attaching SkipContentHandler');
        const handler = container.resolve('skipContentHandler');
        handler.init(nav);
    });

    /**
     * Gestione del toggle di un link.
     * Attacco il listener su tutto il documento così da usare l'event delegation.
     */
    (function() {

        document.addEventListener('click', function(event) {
            var trigger = event.target.closest('[data-ajax-toggle], [data-ajax-hide], [data-ajax-form], [data-ajax-replace]');
            if (trigger === null) {
                return false;
            }
            event.preventDefault();
            event.stopPropagation();

            if (trigger.hasAttribute('href')) {
                var href = trigger.getAttribute('href');
            } else if (trigger.hasAttribute('data-href')) {
                var href = trigger.getAttribute('data-href');
            }

            const fetchHtml = container.resolve('fetchHtml');
            const fetchJson = container.resolve('fetchJson');

            switch (true) {

                // carica all'interno del trigger (bottone) il risultato della chiamata ajax
                case trigger.hasAttribute('data-ajax-toggle'):
                    fetchHtml.fetch(trigger.getAttribute('data-ajax-toggle'), trigger);
                    break;

                /**
                 * Esegue la chiamata presente nell'indirizzo di data-href.
                 * Se la funzione ritorna "success" viene nascosto l'elemento indicato in data-ajax-hide.
                 * Funziona bene nel caso di cancellazione righe in modalità ajax.
                 */
                case trigger.hasAttribute('data-ajax-hide'):
                    if (href === undefined) {
                        throw new Error('href or data-href not present!');
                    }
                    fetchJson.fetch(href, null, function(json) {
                        if (json.success) {
                            var elements = document.querySelectorAll(trigger.getAttribute('data-ajax-hide'));
                            [].forEach.call(elements, function(element) {
                                element.classList.add('d-none');
                            });
                        }
                    })
                    break;

                /**
                 * Associando data-ajax-form e data-ajax-target al bottone di invio di una form
                 * questa spedirà il risultato al data-ajax-target indicato.
                 */
                case trigger.hasAttribute('data-ajax-form') && trigger.hasAttribute('data-ajax-target'):
                    var selector = trigger.getAttribute('data-ajax-form');
                    var form = document.querySelector(selector);
                    if (form !== null) {
                        fetchHtml.fetch(form.getAttribute('action'), trigger.getAttribute('data-ajax-target'), {
                            'method': 'POST',
                            'body':    new FormData(form)
                        });
                        break;
                    }
                    console.log('Form not found!');
                    break;

                // invia al target il risultato della chiamata ajax all'indirizzo href o data-href
                case trigger.hasAttribute('data-ajax-replace'):
                    if (href === undefined) {
                        throw new Error('href or data-href not present!');
                    }
                    fetchHtml.fetch(href, trigger.getAttribute('data-ajax-replace'));
                    break;
            }
            return true;
        });
    })();

    // ModalManager
    observer.attachCallback((node) =>{
        console.log('Attaching ModalManager');
        const modalManager = container.resolve('modalManager');
        modalManager.observe(node);
    }, true);

    // ModalManager
    container.resolve('articleEditorFragments').init();
    container.resolve('articleEditDrag').init();
    container.resolve('articleImageGallery').init();

    // One delegated copy handler for page URLs, section permalinks and text.
    const clipboardCopy = container.resolve('clipboardCopy');
    clipboardCopy.attach();

    // Flash 
    const flash = container.resolve('flash');
    window.flash = flash;
}
